/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React layouts
import RotatingCard from "layouts/Cards/RotatingCard";
import RotatingCardFront from "layouts/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "layouts/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "layouts/Cards/InfoCards/DefaultInfoCard";

import ContactUs from "layouts/pages/landing-pages/contact-us";

// Images
import bgFront from "assets/images/pexels-lina-kivaka.jpg";
import bgBack from "assets/images/pexels-lina.jpg";

let iconColor = "primary";

function Information() {
  return (
    <MKBox component="section" py={2} my={2} mb={4}>
      <Container>
        <Grid container item xs={11} spacing={1} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                color="primary"
                image={bgFront}
                icon="touch_app"
                title={
                  <>
                    Toca para ver
                    <br />
                    Nuestros horarios
                  </>
                }
                description=""
              />
              <RotatingCardBack
                color="error"
                image={bgBack}
                title="Horarios flexibles"
                description="Atención de lunes a viernes (4:00 pm a 6:30 pm) sábado (10:00 am a 3:00 pm)  "
                action={{
                  type: "internal",
                  route: "/contact-us",
                  component: <ContactUs />,
                  label: "contactanos",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  color={iconColor}
                  icon="auto_stories"
                  title="Lectura"
                  description="Potenciar habilidades de lectura e interpretación de textos"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  color={iconColor}
                  icon="history_edu"
                  title="Escritura"
                  description="Mejorar la escritura y expresiones de palabras"
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  color={iconColor}
                  icon="calculate"
                  title="Aritmetica"
                  description="Elevar el potencial lógico aritmético, identificación de números y operaciones aritméticas."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  color={iconColor}
                  icon="psychology"
                  title="Otros"
                  description="Apoyo con planes de mejoramiento, recuperaciones y tareas."
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
